import { render, staticRenderFns } from "./productreal.vue?vue&type=template&id=c4dce36c&"
import script from "./productreal.vue?vue&type=script&lang=js&"
export * from "./productreal.vue?vue&type=script&lang=js&"
import style0 from "./productreal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports